module.exports = __webpack_public_path__ + "img/displacement2.ab4f3f7d.jpg";